import { useTranslation } from 'react-i18next'

import { Button, Modal } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeleteReturnReasonModal = ({ show, onClose, onDelete }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Eliminar motivo de devolución')} size="m">
      <Styles.Container>
        <Styles.Text>{t('Esta acción no se podrá deshacer. ¿Quieres continuar?')}</Styles.Text>
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <Button fullWidth onClick={onDelete}>
            {t('Aceptar')}
          </Button>
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default DeleteReturnReasonModal
